import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  isDescargaApp: boolean = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Comprobar la URL activa al iniciar
    this.isDescargaApp = this.router.url.includes('descarga-app');
    // console.log('URL inicial:', this.router.url);
    // console.log('isDescargaApp inicial:', this.isDescargaApp);

    // Escuchar cambios de navegación
    this.router.events.subscribe(() => {
      this.isDescargaApp = this.router.url.includes('descarga-app');
      // console.log('Cambio de URL detectado:', this.router.url);
      // console.log('isDescargaApp actualizado:', this.isDescargaApp);
    });
  }
}
